module.exports = __webpack_public_path__ + "c6c744491b09b3f2bb616ec372d0b2e8.pdf";